import React from 'react';
const CombineComponents = (components) => components.reduce((AccumulatedComponents, CurrentComponent) => ({ children }) => (React.createElement(AccumulatedComponents, null,
    React.createElement(CurrentComponent, null, children))), ({ children }) => React.createElement(React.Fragment, null, children));
export default CombineComponents;
